import { SymmetricWeightedEdge } from "./symmetric-weighted-edge";
import { Node } from '../lib/node';
import { FindPathSymDGBuilder } from "../specific/find-path-sym-dgbuilder";

export abstract class WeightedSymmetricDirectedGraph extends FindPathSymDGBuilder {
    latestAddedEdge: SymmetricWeightedEdge = null;

   
    addEdge(from: Node, to: Node) {
        if (from == to)
            return;

        //Node has been deleted, hence cant be used to connect
        if (this.nodes.indexOf(from) == -1 || this.nodes.indexOf(to) == -1) {
            return;
        }

        from.addNeighbor(to);
        to.addNeighbor(from);
        
        if (!this.existsEdge(from, to)) {
            let edge: SymmetricWeightedEdge = new SymmetricWeightedEdge(from, to);
            this.edges.push(edge);
            this.latestAddedEdge = edge;
        }
        this.update();

    }

    getEdge(fromNode: Node, toNode: Node): SymmetricWeightedEdge {
        var searchEdge: SymmetricWeightedEdge = null;
        this.edges.forEach(edge => {
            if (edge.getFromNode().getId() == fromNode.getId() && edge.getToNode().getId() == toNode.getId()
             || (edge.getFromNode().getId() == toNode.getId() && edge.getToNode().getId() == fromNode.getId())) {
                searchEdge = <SymmetricWeightedEdge>edge;
            }
        });
        return searchEdge;
    }

    setWeight(weight: number) {
        if (this.latestAddedEdge == null)
            return;

        this.latestAddedEdge.setWeight(weight);
        this.latestAddedEdge = null;
    }

    getWeight(edge: SymmetricWeightedEdge): number {
        return edge.getWeight();
    }

}
